import {
  ApplicationConfig,
  inject,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import {
  getAccessTokenFromStorage,
  provideCeiSsoBootstrap,
  runtimeConfig,
} from '@cei-ufg/ngx-cei-sso-client';
import { credenciaisMapper } from './constants/credenciais-mapper';
import {
  Configuration as SegurancaConfiguration,
  CeiSessionRbacSyncService,
  provideCeiAuthorization,
} from '@cei-ufg/ngx-cei-seguranca';
import { provideCeiApiClients } from '@cei-ufg/ngx-arquitetura-cei-commons';
import {
  provideCeiHttpClient,
  provideCeiHttpErrorHandling,
  provideCeiMask,
  provideCeiSessionCountdown,
  provideCeiSobreVersoes,
} from '@cei-ufg/ngx-arquitetura-cei-frontend';
import { Configuration as AppApiConfiguration } from './api/generated';
import { versoesFrontendAplicacao } from './config/versoes-aplicacao.config';

const ACCESS_TOKEN_KEYS = ['access_token', 'access', 'token', 'accessToken'] as const;

const resolveDomainBasePath = () => runtimeConfig?.apiUrl || environment.apiUrl;
const resolveAuthzBasePath = () =>
  runtimeConfig?.urlBaseApiAutorizacao ||
  environment.urlBaseApiAutorizacao ||
  resolveDomainBasePath();
const resolveAccessToken = () =>
  getAccessTokenFromStorage([...ACCESS_TOKEN_KEYS], 'localStorage');

export const appConfig: ApplicationConfig = {
  providers: [
    // Rotas padrão PT: /proibido, /erro-servidor, /nao-encontrado (ver provideCeiAuthorization).
    provideCeiHttpErrorHandling(),
    provideCeiHttpClient(),
    provideAnimationsAsync(),
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideCeiSsoBootstrap({
      environment,
      credenciaisPayload: credenciaisMapper,
      accessTokenKeys: ACCESS_TOKEN_KEYS,
      onSessionReady: () => {
        inject(CeiSessionRbacSyncService).start();
      },
    }),
    provideCeiApiClients({
      segurancaConfiguration: SegurancaConfiguration,
      domainConfiguration: AppApiConfiguration,
      resolveDomainBasePath,
      resolveAuthzBasePath,
      resolveAccessToken,
    }),
    provideCeiSessionCountdown({
      config: {
        sessionInfoPath: '/auth/session/',
        sessionTimeSource: 'access_token',
      },
    }),
    provideCeiAuthorization({
      config: {
        unauthorizedRedirect: '/proibido',
        unauthenticatedRedirect: '/login',
        loadErrorRedirect: '/erro-servidor',
      },
    }),
    provideCeiMask(),
    provideCeiSobreVersoes({
      versoesFrontend: versoesFrontendAplicacao,
      resolveUrlBaseApi: resolveDomainBasePath,
      resolveAccessToken,
    }),
  ],
};
